import { clampRange } from "../numbers.js";
function getProgress({ presentationProgress, portion, at, }) {
    if (at === "start") {
        return clampRange(presentationProgress * (1 / portion), { min: 0, max: 1 });
    }
    else {
        return clampRange((presentationProgress - (1 - portion)) * (1 / portion), {
            min: 0,
            max: 1,
        });
    }
}
function assertRange(name, value) {
    if (value < 0 || value > 1) {
        throw Error(`${name} must be between 0 and 1`);
    }
}
/**
 * Split presentation progress into two values by returning two progress values;
 * one used for 'entering' and one for 'exiting'. Both progress values go from 0 to 1.
 *
 * This makes it easy to e.g. animate
 * an 'entering' presentation for the first 50% of the presentation and then
 * animate the 'exiting' presentation for the last 50% of the transition.
 */
export function getSplitPresentationProgress({ presentationProgress, presentationDirection, exitingPortionAt = "start", enteringPortionAt = "end", ...portionProps }) {
    if ("portion" in portionProps) {
        assertRange("portion", portionProps.portion);
    }
    else {
        assertRange("enteringPortion", portionProps.enteringPortion);
        assertRange("exitingPortion", portionProps.exitingPortion);
    }
    const enteringPortion = "portion" in portionProps
        ? portionProps.portion
        : portionProps.enteringPortion;
    const exitingPortion = "portion" in portionProps
        ? portionProps.portion
        : portionProps.exitingPortion;
    const exitingProgress = getProgress({
        presentationProgress,
        portion: exitingPortion,
        at: exitingPortionAt,
    });
    const enteringProgress = getProgress({
        presentationProgress,
        portion: enteringPortion,
        at: enteringPortionAt,
    });
    const progress = presentationDirection === "exiting" ? exitingProgress : enteringProgress;
    return {
        enteringProgress,
        exitingProgress,
        progress,
    };
}
